/**
 *@author zhr
 *@description 高级查询组件
 */
import Component from "../../../../lib/component";
import template from './expert-search.html';
import expertCondition from './expert-search-condition/expert-search-condition';
import expertConditionAdQuery from './expert-search-condition-simple/expert-search-condition-adQuery/expert-search-condition-adQuery';
import expertLeftMenu from './expert-search-condition-simple/expert-search-left-menu/expert-search-left-menu'
import {dataTableService} from '../../../../services/dataGrid/data-table.service';
import searchImport from '../expert-search-import/search-import'
import {searchExport} from '../expert-search-export/search-export'
import {Uploader} from '../../../../lib/uploader'
import {PMAPI,PMENUM} from '../../../../lib/postmsg';
import {HTTP} from "../../../../lib/http";
import DateTimeControl from "../../../form/datetime-control/datetime-control";
import DateControl from "../grid-data-control/grid-data-control";
import TimeControl from "../../../form/time-control/time-control";
import Mediator from "../../../../lib/mediator"
import addQuery from '../common-query-add/common-query-add.js';
import msgBox from '../../../../lib/msgbox';
import dataTableAgGrid from '../../data-table-page/data-table-agGrid/data-table-agGrid'
import './expert-search.scss';

let expertSearch = Component.extend({
    template: template,
    ulChecked: true,
    inputValue: null,
    radioId: 0,
    id: null,
    name:'',
    autoSearch: false,
    isEdit: false,
    itemChecked:false,
    itemDeleteChecked:false,
    optionHtmlOne : `<option value="$regex">包含</option>
                    <option value="nor">不包含</option>
                    <option value="exact">等于</option>
                    <option value="$ne">不等于</option>`,
    optionHtmlTwo : `<option value="$regex">包含</option>
                    <option value="exact">等于</option>
                    <option value="$gt">大于</option>
                    <option value="$lt">小于</option>
                    <option value="$ne">不等于</option>`,
    optionHtmlThree : `<option value="exact">等于</option>
                    <option value="$gt">大于</option>
                    <option value="$lt">小于</option>
                    <option value="$ne">不等于</option>`,
    optionHtmlFour : `<option value="exact">等于</option>
                      <option value="$ne">不等于</option>`,
    data: {
        renderId:'',
        renderDom:null,
        tableId: null,
        addNameAry:[],
        saveCommonQuery: false,
        deleteCommonQuery: false,
        key:'',
        commonQuerySelectLength:null,
        //高级查询字段信息
        searchInputAry:[],
        searchInputList:[],
        fieldsData: [],
        commonQuery: [],
        queryParams:[],
        // postExpertSearch: function(data){
        //
        // },
        // getExpertSearchData:function(data){
        //
        // },
        // saveTemporaryCommonQuery:function(data){
        //
        // }
        childComponents:[],
        isAdQuery:0 ,//是否开启简版功能
    },
    actions: {
        /*
        * 限制字符串长度，超过用...代替
        * param:text  string
        * param:len   number 最大显示的字符串长度
        */
        hideText:function(text,len){
            let name;
            if (text.length>len){
                name = text.substring(0,len)+'...';
            }
            return name
        },
        //简版高级查询左菜单全屏/小屏是否限制字段长度
        expertItemDataForEach:function(data,leftWidth,isLimit){
            data.forEach((item)=>{
                if (isLimit) {
                    if (item.name.length>leftWidth){
                        if (item.title&&item.title.length!=item.name.length) return;
                        item.title=item.name;
                        item.name=this.actions.hideText(item.name,leftWidth);
                    }
                    else {
                        return item.name
                    }
                }
                else {
                    return item
                }

            })
        },
        //简版高级查询左菜单切换为全屏时字段显示全部
        leftMenuFieldsDataLen:function(){
            let searchName=this.el.find('.search-name');
            for(let i of searchName){
                    if ((i.getAttribute('title').length&&i.innerText.length)>=13) {
                        i.innerText = i.getAttribute('title')
                    }
                }
        },
        //简版高级查询左菜单切换为小屏时字段限制
        smallLeftMenuFieldsDataLen:function(){
            let searchName=this.el.find('.search-name');
            for(let i of searchName){
                if ((i.getAttribute('title').length&&i.innerText.length)>10) {
                    i.innerText = this.actions.hideText(i.innerText,10)
                }
            }
        },
        //渲染第一个查询条
        rendSearchItem: function(){
            this.data.searchInputAry = [];
            let epCondition;
            if(this.data.isAdQuery){
                epCondition = new expertLeftMenu({data:{expertItemData:this.data.fieldsData},events:{
                    checkedQuery: (choosed)=> {
                        this.actions.checkedQuery(choosed);
                    }
                }});
                epCondition.render(this.el.find('.left-menu'));
            }else {
                epCondition = new expertCondition({data:{expertItemData:this.data.fieldsData}});
                let dom = document.createElement('div');
                dom.className = 'condition-search-choice';
                this.append(epCondition, $(dom));
                $(dom).appendTo(this.el.find('.condition-search-container'));
                // this.append(epCondition, this.el.find('.condition-search-container'));
                this.data.searchInputAry.push(epCondition.data);
            }
            this.el.find('.condition-search-item').css({'paddingLeft':'83px','borderTop':'1px solid #e4e4e4'});
            this.el.find('.condition-search-select.radio').css('display','none');
            this.el.find('.condition-search-delete').css('visibility','hidden');
            this.el.find('.left-choice').addClass('active');
            this.el.find('.right-choice').addClass('active');
        },
        //获取高级查询数据
        getExpertSearchData: function () {
            let obj = {'actions':JSON.stringify( ['queryParams'] ),'table_id':this.data.tableId};
            dataTableService.getPreferences( obj ).then( res=>{
                let rows = [];
                let isFilter=this.data.isAdQuery ? 1:undefined;
                //筛选两版常用查询数据
                rows = res.rows.filter((item)=>{
                    return (JSON.parse(item.queryParams).length>0) && (JSON.parse(item.queryParams)[0].isAdQuery == isFilter);
                })
                res.rows = rows;
                this.data.commonQuery = res.rows;
                this.el.find('.common-search-item').remove();
                this.data.commonQuery.forEach((item)=> {
                    this.actions.appendItem(item);
                });
                if(this.data.commonQuery.length != 0){
                    this.el.find('.common-search-compile').css('display','block');
                }
            } );
            HTTP.flush();
        },
        // 获取查询数据
        submitData: function (name){
            this.data.searchInputList = [];
             let itemList = this.el.find('.condition-search-item');
            if(this.data.isAdQuery){
                let valList = this.el.find('.condition-search-value');
                for(let i = 0; i < valList.length; i++) {
                    let obj = {
                        cond: {
                            //leftBracket:0,
                            //rightBracket:0,
                            operate:'$regex'
                        },
                        relation:'$and',
                        isAdQuery: this.data.isAdQuery
                    };
                   if(this.el.find('.type-name').eq(i).attr('type') == 'date'  ||
                       this.el.find('.type-name').eq(i).attr('type') == 'datetime' ||
                       this.el.find('.type-name').eq(i).attr('type') == 'time' ||
                       this.el.find('.type-name').eq(i).attr('type') == 'number' ||
                       this.el.find('.type-name').eq(i).attr('type') == 'year' ||
                       this.el.find('.type-name').eq(i).attr('type') == 'year-month'
                   ) {
                        let type = this.el.find('.type-name').eq(i).attr('type');
                        obj['cond']['operate'] = '$lte,$gte';
                        obj['cond']['type'] = this.el.find('.type-name').eq(i).attr('type');
                        let val = this.el.find('.condition-search-value').eq(i).find('input');
                        let reDateTime
                        switch (type){
                            // case 'datetime':
                            //     reDateTime = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1])) (?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/;
                            //     break;
                            // case 'date':
                            //     reDateTime = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1]))$/;
                            //     break;
                            // case 'time':
                            //     reDateTime = /^(?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/;
                            //     break;
                            case 'datetime':
                                reDateTime = '年-月-日 时:分:秒';
                                break;
                            case 'date':
                                reDateTime = '年-月-日';
                                break;
                            case 'time':
                                reDateTime = '时:分:秒';
                                break;
                        }
                        const input1 = $.trim(val[0].value);//下限
                        const input2 = $.trim(val[1].value);//上限
                        // if($.trim(val[0].value) != reDateTime && $.trim(val[1].value) != reDateTime && $.trim(val[0].value) != '' && $.trim(val[1].value) != '') {
                        //     obj['cond']['keyword'] =$.trim(val[0].value)+','+$.trim(val[1].value);
                        // }else {
                        //     obj['cond']['keyword'] = '';
                        // }

                        //优化逻辑:如果上下限都为空给提示
                        if (!input1&&!input2){
                            msgBox.alert('查询值不能为空')
                            return
                        }
                        else if (input1||input2){
                            obj['cond']['keyword'] =$.trim(val[0].value)+','+$.trim(val[1].value);
                        }

                    }else if(this.el.find('.type-name').eq(i).attr('type') == 'select'){
                        let selectVal = this.el.find('.condition-search-value').eq(i).find('.my-light-btn-click').val();
                        obj['cond']['keyword'] = selectVal != undefined ? selectVal : '';
                    }else if(this.el.find('.type-name').eq(i).attr('type') == 'multi-select'){
                        let multiHtml = this.el.find('.condition-search-value').eq(i).find('.my-light-btn-click');
                        let multiVal = [];
                        for(let k=0; k<multiHtml.length; k++) {
                            multiVal.push(multiHtml[k].value);
                        }
                        obj['cond']['keyword'] =  multiVal.length >0 ? multiVal :'';
                        obj['cond']['operate'] = '$in';
                    }else {
                       if(this.el.find('.condition-search-select.relation').eq(i).val() == 'nor') {
                           let keyword = this.el.find('.condition-search-value').eq(i).find('input').val();
                           obj['cond']['operate'] = '$regex';
                           obj['cond']['keyword'] = `^((?!${keyword}).)*$`;
                       }
                       else {
                           obj['cond']['keyword'] = this.el.find('.condition-search-value').eq(i).find('input').val();
                       }
                    }
                    if(this.el.find('.condition-search-choice.left-choice').eq(i).hasClass('active')){
                        obj['cond']['leftBracket'] = '('
                    } else {
                        obj['cond']['leftBracket'] = '0'
                    }
                    if(this.el.find('.condition-search-choice.right-choice').eq(i).hasClass('active')){
                        obj['cond']['rightBracket'] = ')'
                    } else {
                        obj['cond']['rightBracket'] = '0'
                    }
                    obj['cond']['searchBy'] = this.el.find('.type-name').eq(i).attr('id');
                    obj['cond']['searchByName'] = this.el.find('.type-name').eq(i).text();
                    obj['cond']['searchByNew'] = this.el.find('.type-name').eq(i).attr('id');
                    //obj['relation'] = this.el.find('.type-name').eq(i).attr('radio');
                    obj['relation'] = this.el.find('.condition-search-select.radio').eq(i).val();
                    this.data.searchInputList.push(obj);
                    console.log('searchInputList')
                    console.log(this.data.searchInputList)
                }
            }else {
                for(let i = 0; i < itemList.length; i++) {
                    let obj = {
                        cond: {},
                        relation:'$and',
                    };

                    // if(this.data.searchInputAry[i].inputBoxTitle == 'number') {
                    //     obj['cond']['keyword'] = parseInt(this.data.searchInputAry[i].inputValue);
                    // } else {
                    //     obj['cond']['keyword'] = this.data.searchInputAry[i].inputValue;
                    // }
                    // obj['cond']['leftBracket'] = this.data.searchInputAry[i].leftSelect;
                    // obj['cond']['operate'] = this.data.searchInputAry[i].relationSelect;
                    // obj['cond']['rightBracket'] = this.data.searchInputAry[i].rightSelect;
                    // obj['cond']['searchBy'] = this.data.searchInputAry[i].inputBoxValue;
                    // obj['cond']['searchByName'] = this.data.searchInputAry[i].inputBoxName;
                    // obj['cond']['searchByNew'] = this.data.searchInputAry[i].inputBoxValue;
                    // if(this.el.find('.condition-search-radio.or').eq(i).prop('checked') == true) {
                    //     obj['relation'] = '$or';
                    // }

                    //由于选择一个常用查询后 改变其查询值 new一个组件时push到数组的值是不会发生变化的
                    if(this.el.find('.result').eq(i).attr('search-type') == 'number') {
                        obj['cond']['keyword'] = Number(this.el.find('.condition-search-value').find('input').eq(i).val());
                        obj['cond']['operate'] = this.el.find('.condition-search-select.relation').eq(i).val()
                    } else if(this.el.find('.result').eq(i).attr('search-type') == 'date') {
                        obj['cond']['keyword'] = $.trim(this.el.find('.condition-search-value').find('input').eq(i).val());
                        obj['cond']['operate'] = this.el.find('.condition-search-select.relation').eq(i).val()
                    } else {
                        if(this.el.find('.condition-search-select.relation').eq(i).val() == 'nor') {
                            let keyword = this.el.find('.condition-search-value').find('input').eq(i).val();
                            obj['cond']['operate'] = '$regex';
                            obj['cond']['keyword'] = `^((?!${keyword}).)*$`;
                        }
                        else {
                            obj['cond']['keyword'] = this.el.find('.condition-search-value').find('input').eq(i).val();
                            obj['cond']['operate'] = this.el.find('.condition-search-select.relation').eq(i).val()
                        }
                    }
                    if(this.el.find('.condition-search-choice.left-choice').eq(i).hasClass('active')){
                        obj['cond']['leftBracket'] = '('
                    } else {
                        obj['cond']['leftBracket'] = '0'
                    }
                    if(this.el.find('.condition-search-choice.right-choice').eq(i).hasClass('active')){
                        obj['cond']['rightBracket'] = ')'
                    } else {
                        obj['cond']['rightBracket'] = '0'
                    }
                    // obj['cond']['operate'] = this.el.find('.condition-search-select.relation').eq(i).val()

                    obj['cond']['searchBy'] = this.el.find('.result').eq(i).attr('name');
                    obj['cond']['searchByName'] = this.el.find('.result').eq(i).val();
                    obj['cond']['searchByNew'] = this.el.find('.result').eq(i).attr('name');
                    obj['relation'] = this.el.find('.condition-search-select.radio').eq(i).val();
                    this.data.searchInputList.push(obj);
                }

            }

            this.actions.checkedSubmitData(name)
        },
        //展示常用查询
        showSearchData: function(data) {
            this.data.renderId = '';
            let searchData = data;
            this.el.find('.condition-search-container').find('div').remove();
            this.actions.rendSearchItem();
            // console.log('---------------常用查询----------')
            //console.log(searchData)
            if(this.data.isAdQuery) {
                let types = {};
                let newList = [];
                //把相同类型的item分到一组
                // 按 list 中 type 的顺序生成新的列表
                // 每个元素都是一个 { type, items }
                searchData.forEach(function(item) {
                    let typeItems = types[item.cond.searchBy];
                    // typeItems 无值说明映射表里还没加入这个 type
                    if (!typeItems) {
                        // 产生一个新的 items 列表
                        typeItems = [];
                        // 将 type 这个 items 列表加入映射表
                        types[item.cond.searchBy] = typeItems;
                        // 因为是个新的 type，所以加入 newList
                        newList.push({
                            type: item.cond.searchBy,
                            items: typeItems
                        });
                    }
                    // 这里 items 就是按类型找到的元素组
                    // 在 items 中加入当前 item
                    typeItems.push(item);
                });
                //给相同组的第一个items添加属性 isAdd:true, 其余isAdd:false
                newList.forEach((item)=> {
                    if(item['items'].length>1) {
                        item['items'].forEach((it,index)=>{
                            if(index === 0) {
                                it['isAdd'] = false
                            }else {
                                it['isAdd'] = true;
                            }
                        })
                    }
                })
                let choosed =  [];
                newList.forEach((item)=> {
                    item['items'].forEach((it)=>{
                        let obj = {}
                        obj['id'] = it['cond'].searchBy;
                        obj['checked'] = true;
                        // obj['multChoosed'] = it['cond']['keyword']
                        obj['isAdd'] = it['isAdd'];
                        choosed.push(obj);
                    })
                })
                //渲染左侧导航栏
                let epCondition = new expertLeftMenu({data:Object.assign({expertItemData:this.data.fieldsData},{choosed:choosed}),events:{
                    checkedQuery: (choosed)=> {
                        this.actions.checkedQuery(choosed);
                    }
                }});
                epCondition.render(this.el.find('.left-menu'));
                //左菜单字段全屏/小屏的显示
                this.el.height()==556?this.actions.smallLeftMenuFieldsDataLen():this.actions.leftMenuFieldsDataLen();

                for(let j = 0;j<searchData.length;j++){
                    let html = this.actions.checkedRelationTypeAdQuery(searchData[j]['cond']['searchByName']);
                    this.actions.checkedInputTypeAdQuery(searchData[j]['cond']['searchByName'],searchData[j]['cond']['keyword'],j,html,searchData[j]['cond']['operate']);
                    if(searchData[j]['cond']['leftBracket'] == '(') {
                        this.el.find('.condition-search-choice.left-choice').eq(j).addClass('active')
                    } else {
                        this.el.find('.condition-search-choice.left-choice').eq(j).removeClass('active')
                    }
                    if(searchData[j]['cond']['rightBracket'] == ')') {
                        this.el.find('.condition-search-choice.right-choice').eq(j).addClass('active')
                    } else {
                        this.el.find('.condition-search-choice.right-choice').eq(j).removeClass('active')
                    }
                    this.el.find('.condition-search-select.radio').eq(j).val(searchData[j]['relation']);
                }

            }else {
                for(let i = 0; i<searchData.length-1; i++) {
                    let epCondition = new expertCondition({data:{expertItemData:this.data.fieldsData}});
                    let dom = document.createElement('div');
                    dom.className = 'condition-search-choice';
                    this.append(epCondition, $(dom));
                    $(dom).appendTo(this.el.find('.condition-search-container'));
                }
                for(let j = 0;j<searchData.length;j++) {
                    let html = this.actions.checkedRelationType(searchData[j]['cond']['searchByName']);
                    this.actions.checkedInputType(searchData[j]['cond']['searchByName'],searchData[j]['cond']['keyword'],j,html,searchData[j]['cond']['operate']);
                    if(searchData[j]['cond']['leftBracket'] == '(') {
                        this.el.find('.condition-search-choice.left-choice').eq(j).addClass('active')
                    } else {
                        this.el.find('.condition-search-choice.left-choice').eq(j).removeClass('active')
                    }
                    if(searchData[j]['cond']['rightBracket'] == ')') {
                        this.el.find('.condition-search-choice.right-choice').eq(j).addClass('active')
                    } else {
                        this.el.find('.condition-search-choice.right-choice').eq(j).removeClass('active')
                    }
                    // this.el.find('.condition-search-select.relation').eq(j).html(html)
                    // this.el.find('.condition-search-select.relation').eq(j).val(searchData[j]['cond']['operate']);
                    this.el.find('.result').eq(j).attr('name',searchData[j]['cond']['searchBy']);
                    this.el.find('.result').eq(j).val(searchData[j]['cond']['searchByName']);
                    this.el.find('.result').eq(j).attr('name',searchData[j]['cond']['searchByNew']);
                    this.el.find('.condition-search-select.radio').eq(j).val(searchData[j]['relation']);
                }
            }

        },
        //加载不同查询条件的查询关系
        checkedRelationType: function(value){
            let htmlStr;
            this.data.fieldsData.forEach((item)=> {
                if(item.name == value) {
                    switch (item.searchType) {
                        case "datetime": htmlStr = this.optionHtmlTwo; break;
                        case "text": htmlStr = this.optionHtmlOne; break;
                        case "number": htmlStr = this.optionHtmlThree; break;
                        case "person": htmlStr = this.optionHtmlFour; break;
                    }
                }
            });
            return htmlStr;
        },
        //加载不同查询条件的查询关系-简版
        checkedRelationTypeAdQuery: function(value){
            let htmlStr;
            this.data.fieldsData.forEach((item)=> {
                if(item.name == value) {
                    switch (item.searchType) {
                        case "text":
                            htmlStr = `<option value="$regex">包含</option>
                                       <option value="nor">不包含</option>`;
                            break;
                    }
                }
            });
            return htmlStr;
        },
        //加载不同查询条件的输入框类型-简版
        checkedInputTypeAdQuery: function(type, value,index,html,relation){
            this.data.fieldsData.forEach((item)=> {
                if(item.name == type || item.name.indexOf(type.replace('...','')) === 0) {
                    if(item.searchType === 'datetime' || item.searchType === 'date' || item.searchType === 'time'|| item.searchType === 'year' || item.searchType === 'year-month'){
                        this.el.find('.condition-search-value').eq(index).find('input')[0].value = value.split(',')[0];
                        this.el.find('.condition-search-value').eq(index).find('input')[1].value = value.split(',')[1];
                    }else if(item.searchType === "number") {
                        let h = this.el.find('.condition-search-value').eq(index).find('.condition-search-input');
                        let val = value.split(',');
                        h[0].value = val[0];
                        h[1].value = val[1];
                    }else if(item.searchType === "select"){
                        let len = this.el.find('.condition-search-value').eq(index).find('button').length;
                        for(let i=0 ; i<len; i++) {
                            if( this.el.find('.condition-search-value').eq(index).find('button')[i].value == value ) {
                                $(this.el.find('.condition-search-value').eq(index).find('button')[i]).addClass('my-light-btn-click')
                            }else {
                                $(this.el.find('.condition-search-value').eq(index).find('button')[i]).removeClass('my-light-btn-click')
                            }
                        }
                    }else if(item.searchType === "multi-select"){
                        let len = this.el.find('.condition-search-value').eq(index).find('button').length;
                        for(let i=0 ; i<len; i++) {
                            Array.from(value).forEach((item) => {
                                if( this.el.find('.condition-search-value').eq(index).find('button')[i].value == item ) {
                                    $(this.el.find('.condition-search-value').eq(index).find('button')[i]).addClass('my-light-btn-click')
                                }
                            })
                        }
                    }else if(item.searchType === "text"){
                        let str = /\^\(\(\?!/;
                        this.el.find('.condition-search-select.relation').eq(index).html(html);
                        if(str.test(value)){
                            let length = value.length - 5;
                            let newValue = value.substring(5,length);
                            this.el.find('.condition-search-value').eq(index).find('.condition-search-input').val(newValue);
                            this.el.find('.condition-search-select.relation').eq(index).val('nor');
                        } else {
                            this.el.find('.condition-search-select.relation').eq(index).val(relation);
                            this.el.find('.condition-search-value').eq(index).find('.condition-search-input').val(value);
                        }
                    }
                }
            })
        },
        //加载不同查询条件的输入框类型
        checkedInputType: function(type, value, index, html, relation){
            this.data.fieldsData.forEach((item)=> {
                if(item.name == type) {
                    switch (item.searchType) {
                        case "datetime":
                            this.el.find('.result').eq(index).attr('search-type','datetime');
                            this.el.find('.condition-search-input').eq(index).remove();
                            let dateTimeControl = new DateTimeControl({data:{value: value, isAgGrid: true},events:{changeValue:function(data){}}});
                            dateTimeControl.render(this.el.find('.condition-search-value').eq(index));
                            this.el.find('.condition-search-select.relation').eq(index).html(html);
                            this.el.find('.condition-search-select.relation').eq(index).val(relation);
                            break;
                        case "date":
                            this.el.find('.result').eq(index).attr('search-type','date');
                            this.el.find('.condition-search-input').eq(index).remove();
                            let dateControl = new DateControl({data:{value: value, isAgGrid: true},events:{changeValue:function(data){}}});
                            dateControl.render(this.el.find('.condition-search-value').eq(index));
                            this.el.find('.condition-search-select.relation').eq(index).html(html);
                            this.el.find('.condition-search-select.relation').eq(index).val(relation);
                            break;
                        case "time":
                            this.el.find('.result').eq(index).attr('search-type','time');
                            this.el.find('.condition-search-input').eq(index).remove();
                            let timeControl = new TimeControl({data:{value: value, isAgGrid: true},events:{changeValue:function(data){}}});
                            timeControl.render(this.el.find('.condition-search-value').eq(index));
                            this.el.find('.condition-search-select.relation').eq(index).html(html);
                            this.el.find('.condition-search-select.relation').eq(index).val(relation);
                            break;
                        case "text":
                            let str = /\^\(\(\?!/;
                            this.el.find('.condition-search-value').eq(index).html(`<input class="condition-search-input" type="text">`);
                            this.el.find('.condition-search-select.relation').eq(index).html(html);
                            if(str.test(value)){
                                let length = value.length - 5;
                                let newValue = value.substring(5,length);
                                this.el.find('.condition-search-value').eq(index).find('.condition-search-input').val(newValue);
                                this.el.find('.condition-search-select.relation').eq(index).val('nor');
                            } else {
                                this.el.find('.condition-search-select.relation').eq(index).val(relation);
                                this.el.find('.condition-search-value').eq(index).find('.condition-search-input').val(value);
                            }
                            break;
                        case "number":
                            this.el.find('.result').eq(index).attr('search-type','number');
                            this.el.find('.condition-search-value').eq(index).html(`<input value="${value}" class="condition-search-input" type="number">`);
                            this.el.find('.condition-search-select.relation').eq(index).html(html);
                            this.el.find('.condition-search-select.relation').eq(index).val(relation);
                            break;
                        case "person":
                            this.el.find('.condition-search-value').eq(index).html(`<input class="condition-search-input" type="text">`);
                            this.el.find('.condition-search-value').eq(index).find('.condition-search-input').val(value);
                            this.el.find('.condition-search-select.relation').eq(index).html(html);
                            this.el.find('.condition-search-select.relation').eq(index).val(relation);
                            break;
                    }
                }
            })

        },
        //校验提交的高级查询
        checkedSubmitData: function(name) {
            let checkedPost = true,
                leftBracketNum = 0,
                rightBracketNum = 0;
            try {
                this.data.searchInputList.forEach((item) => {
                    if (item['cond']['keyword'] === '') {
                        msgBox.alert('查询值不能为空！');
                        checkedPost = false;
                        foreach.break=new Error("StopIteration");
                    } else if (item['cond']['searchByName'] === '') {
                        msgBox.alert('查询条件不能为空！');
                        checkedPost = false;
                        foreach.break=new Error("StopIteration");
                    }
                    if (item['cond']['leftBracket'] === '(') {
                        leftBracketNum++;
                    }
                    if (item['cond']['rightBracket'] === ')') {
                        rightBracketNum++;
                    }
                })
            } catch (e) {
                if(e.message==="foreach is not defined") {
                    return;
                } else throw e;
            }
            if (checkedPost) {
                if (leftBracketNum == rightBracketNum) {
                    if(name == 'save'){
                        this.actions.openSaveQuery(name);
                    } else {
                        // this.data.saveTemporaryCommonQuery(this.data.searchInputList);
                        let searchId = '临时高级查询',searchName = '临时高级查询',appendChecked = true;
                        this.data.commonQuery.forEach((item) => {
                            if(item.id == this.id && JSON.parse(item.queryParams).length == this.data.searchInputList.length) {
                                for (let i = 0; i< this.data.searchInputList.length; i++) {
                                    if( JSON.parse(item.queryParams)[i]['cond']['keyword'] == this.data.searchInputList[0]['cond']['keyword'] &&
                                        JSON.parse(item.queryParams)[i]['cond']['operate'] == this.data.searchInputList[0]['cond']['operate'] &&
                                        JSON.parse(item.queryParams)[i]['cond']['leftBracket'] == this.data.searchInputList[0]['cond']['leftBracket'] &&
                                        JSON.parse(item.queryParams)[i]['cond']['rightBracket'] == this.data.searchInputList[0]['cond']['rightBracket']&&
                                        JSON.parse(item.queryParams)[i]['cond']['searchBy'] == this.data.searchInputList[0]['cond']['searchBy']&&
                                        JSON.parse(item.queryParams)[i]['cond']['searchByName'] == this.data.searchInputList[0]['cond']['searchByName']
                                    ){
                                        searchId = item.id;
                                        searchName = item.name;
                                        appendChecked = false;
                                    }else {
                                        return false;
                                    }
                                }
                            }
                        });
                        PMAPI.closeIframeDialog(window.config.key, {
                            type:'temporaryQuery',
                            appendChecked:appendChecked,
                            saveCommonQuery:this.data.saveCommonQuery,
                            id:searchId,
                            name:searchName,
                            value: this.data.searchInputList,
                            addNameAry: this.data.addNameAry
                        });
                    }
                } else {
                    msgBox.alert('运算括号出错')
                }
            }
        },
        //取消查询关闭iframe
        // cancelSearch:function() {
        //     PMAPI.closeIframeDialog(window.config.key, {
        //         saveCommonQuery:this.data.saveCommonQuery,
        //         deleteCommonQuery:this.data.deleteCommonQuery,
        //         onlyclose:true
        //     });
        // },
        //打开保存常用查询
        openSaveQuery: function(){
            if(this.isEdit) {
                addQuery.data.name = this.name;
            }
            this.actions.openSaveQueryDialog(addQuery);
        },
        //打开保存常用查询弹窗
        openSaveQueryDialog:function(addQuery){
            PMAPI.openDialogByComponent(addQuery, {
                width: 400,
                height: 170,
                title: '保存为常用查询'
            }).then((data) => {
                if(data.onlyclose){
                    return false
                }
                if(data.value == '') {
                    msgBox.alert('名称不能为空！');
                    // this.actions.openSaveQueryDialog(addQuery)
                }else  {
                    if(!this.isEdit) {
                        this.actions.saveCommonQuery(data.value);
                    } else {
                        this.actions.deleteCommonQuery(this.id,data.value);
                        // this.actions.saveCommonQuery(data.value);
                    }
                }
            });
        },
        appendItem: function (item) {
            if(item.is_admin==1){
                this.el.find('.common-search-list').append(`<li class="common-search-item" admin="${item.is_admin||0}" fieldId="${item.id}">${item.name}</li>`);
            }else {
                this.el.find('.common-search-list').append(`<li class="common-search-item" admin="${item.is_admin||0}" fieldId="${item.id}">${item.name}<span class="item-delete icon-expert-error-msg"></span></li>`);
            }
        },
        //渲染常用查询按钮
        renderQueryItem: function(data){
            data.forEach((item)=> {
                this.actions.appendItem(item);
            })
        },
        //保存临时常用查询
        // saveTemporaryCommonQuery:function() {
        //     this.data.commonQuery.push({
        //         id: '00',
        //         name:'临时常用查询',
        //         queryParams: JSON.stringify(this.data.searchInputList)
        //     })
        //     debugger
        // },
        //保存常用查询
        saveCommonQuery: function(name) {
            // this.data.searchInputList = [{"cond":{leftBracket: 0, rightBracket: 0, operate: "$lte,$gte", keyword1: "2018-05-30 09:39:30", keyword2: "2018-05-30 09:39:31", searchBy: "f1"},"relation":"$or"}];
            let obj = {
                'action': 'queryParams',
                'table_id': this.data.tableId,
                'name': name,
                'queryParams': JSON.stringify(this.data.searchInputList),
            };
            dataTableService.savePreference(obj).then( res=>{
                if(res.succ == 0) {
                    msgBox.alert(res.error)
                } else if(res.succ == 1) {
                    // this.actions.renderQueryItem(this.data.searchInputList)
                    this.data.saveCommonQuery = true;
                    this.data.addNameAry.push(name);
                    this.actions.getExpertSearchData();
                    // this.data.commonQuery.push({
                    //     id:1000+this.data.num,
                    //     name:name,
                    //     queryParams:JSON.stringify(this.data.searchInputList)
                    // });

                    this.name = name;
                    // Mediator.on('renderQueryItem:itemData',data =>{
                    //     this.actions.renderQueryItem(data);
                    // });
                   // this.actions.setConditionHeight()
                }
            });
            HTTP.flush();
        },
        //删除常用查询
        deleteCommonQuery: function(id,value){
            let obj = {
                'table_id': this.data.tableId,
                'id': id
            };
            dataTableService.delPreference(obj).then( res=>{
                if(res.succ == 0) {
                    msgBox.alert(res.error)
                } else if(res.succ == 1) {
                    this.actions.removeQueryItem(id);
                    for(let i = 0; i <this.data.commonQuery.length; i++) {
                        if (this.data.commonQuery[i].id == id){
                            this.data.commonQuery.splice(i,1);
                        }
                    }
                    if(this.data.commonQuery.length == 0){
                        this.el.find('.common-search-compile').css('display','none');
                        this.el.find('.common-search-compile').html(`<span class="img icon-expert-edit"></span><span class="icon-expert-edit-text">编辑</span>`);
                        this.itemDeleteChecked = false;
                    }
                    this.data.deleteCommonQuery = true;
                    if(this.isEdit && value) {
                        this.actions.saveCommonQuery(value);
                        this.el.find('.common-search-compile').html(`<span class="img icon-expert-edit"></span><span class="icon-expert-edit-text">编辑</span>`);
                        this.itemDeleteChecked = !this.itemDeleteChecked;
                        this.isEdit = false;
                    }
                }
            } );
            HTTP.flush();
        },
        //移除常用查询按钮
        removeQueryItem: function(id) {
            let itemLength = this.el.find('.common-search-item').length;
            for(let i = 0; i < itemLength; i++) {
                if(this.el.find('.common-search-item').eq(i).attr('fieldId') == id){
                    this.el.find('.common-search-item').eq(i).remove();
                }
            }
           // this.actions.setConditionHeight()
        },
        //condition-search高度，解决切换全屏/小屏时.common-search值不准确导致显示不全bug，换作媒体查询定高度
        setConditionHeight:function() {
            let height = 450 - parseInt(this.el.find('.common-search').css('height'));
            this.el.find('.condition-search').css('height',`${height}px`);
        },
        // showAddBtn:function() {
        //     let length = this.el.find('.condition-search-item').length;
        //     this.el.find('.condition-search-item').find('.condition-search-add').css('display','none')
        //     this.el.find('.condition-search-item').eq(length-1).find('.condition-search-add').css('display','inline-block')
        // },
        //全屏按钮是否被点击
        isClickFullScreenBtn:function(){
            let btn=parent.document.getElementsByClassName('ui-button-icon')[1];
            this.data.fullScreenClick=false;
            if (!btn)return;
            btn.onclick= ()=> {
                if (this.data.isAdQuery) {
                    this.el.height()==556?this.actions.leftMenuFieldsDataLen():this.actions.smallLeftMenuFieldsDataLen();
                }
            }
        },
        //简版高级查询删除时移除祖先元素
        parentForEach:function(parent){
            let sibling=parent.siblings();
           // if (!parent)return
            if (sibling.length==0) {//父级没兄弟继续找祖先
                let grampa=parent.parent();
                this.actions.parentForEach(grampa)
            }
            else {//父级有兄弟删除父级
                parent.remove()
                return
            }
        },
        // 接受父组件传数据过来后
        afterGetMsg:function() {
            if (this.data.commonQuery.length == 0) {
                this.el.find('.common-search-compile').css('display', 'none')
            } else {
                this.data.commonQuery.forEach((item) => {
                    this.actions.appendItem(item);
                })
            }
            this.actions.rendSearchItem();
            this.itemDeleteChecked = false;
            this.isEdit = false;
            if(this.data.bi) {
                this.el.find('.common-search').css('display', 'none');
                this.el.find('.save-button').css('display', 'none');
                this.el.find('.save-img').css('display', 'none');
                if(this.data.commonQuery.length != 0){
                    this.name = this.data.commonQuery[0].name;
                    this.id = this.data.commonQuery[0].id;
                    this.itemChecked = true;
                    this.data.searchInputList = JSON.parse(this.data.commonQuery[0]['queryParams']);
                    this.actions.showSearchData(JSON.parse(this.data.commonQuery[0]['queryParams']));
                    if (this.itemDeleteChecked) {
                        this.isEdit = true;
                    }
                }
            }
            let _this = this;
            this.el.on('click','.condition-search-add',function(e) {
                // this.append(new expertCondition({expertItemData:this.data.fieldsData}), this.el.find('.condition-search-container'));
                let epCondition
                if(_this.data.isAdQuery){
                    let id = $(e.target).siblings('.type-name')[0].id;
                    let obj = {
                        id:id,
                        checked: true
                    }
                    let selectValue = _this.actions.itemOnSelect(obj);
                    epCondition = new expertConditionAdQuery({data:Object.assign({expertItemData:selectValue},{isAdd:true})});
                    let Dom = document.createElement('div');
                    Dom.className = 'condition-search-choice-child';
                    _this.append(epCondition, $(Dom));
                    $(this).parent().parent().append($(Dom));

                    //添加字段，对并且/或者选框得处理
                    let parentContainerLen = _this.el.find('.condition-search-container').children().length;
                    let radioCss={'display':'inline-block','vertical-align': 'top','margin-left':'-40px'};
                    //如果有number-input
                    let numberInput=$(this).parent().siblings().children().children().children('.condition-search-value').children('.number-input');
                    numberInput.length&&numberInput.parent().css('margin-left','-19px')
                    if (parentContainerLen==1) {
                        $(Dom).children().children().children('select.condition-search-select.icon-aggrid-select.radio').css(radioCss)
                    }
                    else if (parentContainerLen>1) {
                        $(Dom).children().children().children('select.condition-search-select.icon-aggrid-select.radio').css(radioCss)
                    }
                    _this.data.searchInputAry.push(epCondition.data);
                }else{
                    epCondition = new expertCondition({data:{expertItemData:_this.data.fieldsData}});
                    let Dom = document.createElement('div');
                    Dom.className = 'condition-search-choice';
                    _this.append(epCondition, $(Dom));
                    $(this).parent().parent().parent('.condition-search-choice').after($(Dom));
                    _this.data.searchInputAry.push(epCondition.data);
                }
            }).on('click','.condition-search-delete',function(e){
                if (_this.data.isAdQuery){
                    let item=$(this).parent();//item
                    _this.actions.parentForEach(item)
                }
                else {
                    e.target.parentElement.parentElement.parentElement.remove();
                }

            }).on('click','.condition-search-choice.left-choice',function(){
                if($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).addClass('active');
                }
            }).on('click','.condition-search-choice.right-choice',function(){
                if($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).addClass('active');
                }
            }).on('click','.condition-search-radio', function() {
                $(this).parent().parent('.condition-search-radiobox').find('.condition-search-radio').prop('checked',false);
                $(this).prop('checked',true)
            }).on('click','.search-button', ()=> {
                this.actions.submitData()
            }).on('click','.cancel-button',()=>{
                this.actions.cancelSearch()
            }).on('click','.reset-button',function(){
                _this.el.find('.condition-search-container').find('div').remove();
                _this.data.childComponents = [];
                _this.actions.rendSearchItem();
            }).on('click','.common-search-item',function() {
                _this.data.commonQuery.forEach((item) => {
                    if(item.id == this.attributes['fieldId'].nodeValue){
                        _this.name = item.name;
                        _this.id = item.id;
                        _this.itemChecked = true;
                        _this.data.searchInputList = JSON.parse(item.queryParams);
                        _this.actions.showSearchData(JSON.parse(item.queryParams));
                        if(_this.itemDeleteChecked) {
                            _this.isEdit = true;
                        }
                        //admin设置的常用查询不允许编辑
                        if(item.is_admin == 1){
                            msgBox.showTips('无法编辑默认的常用查询设置。')
                            _this.el.find('.save-img').hide();
                            _this.el.find('.save-button').hide();
                        }else {
                            _this.el.find('.save-img').show();
                            _this.el.find('.save-button').show();
                        }
                    }
                })
            }).on('click','.save-button',()=> {
                this.actions.submitData('save');
            }).on('click','.item-delete',function(event) {
                event.stopPropagation();
                _this.actions.deleteCommonQuery($(this).parent('.common-search-item').attr('fieldId'))
            }).on('click','.common-search-compile',function(){
                if(!_this.itemDeleteChecked){
                    _this.el.find('.common-search-list').find('.item-delete').css('display','block');
                    $('.common-search-compile').html('取消');
                    _this.itemDeleteChecked = !_this.itemDeleteChecked;
                } else {
                    _this.el.find('.common-search-list').find('.item-delete').css('display','none');
                    _this.el.find('.common-search-compile').html(`<span class="img icon-expert-edit"></span><span class="icon-expert-edit-text">编辑</span>`);
                    _this.itemDeleteChecked = !_this.itemDeleteChecked;
                    _this.isEdit = false;
                }
            }).on('click','.export', function(){
                if(_this.data.commonQuery.length == 0){
                    msgBox.alert('常用查询为空不能导出！')
                } else {
                    searchExport.export(_this.data.tableId,_this.el);
                }
            }).on('click','.import', function(){
                let choice = 1;
                if(_this.el.find('.common-search-title .choice-input').eq(1).hasClass('active')){
                    choice = 0
                }
                let obj={
                    tableId: _this.data.tableId,
                    parentKey: window.config.key,
                    choice : choice,
                };
                PMAPI.openDialogByIframe(`/iframe/searchImport/`,{
                    width:500,
                    height:400,
                    title:`常用查询导入`,
                    modal:true,
                },{obj}).then(res=>{
                    if(res.type == 1) {
                        _this.actions.getExpertSearchData();
                    }
                })
                // searchImport.import(window.config.key,_this.data.tableId,choice);
            }).on('click','.common-search-title .choice-input', function(){
                _this.el.find('.common-search-title .choice-input').removeClass('active');
                $(this).addClass('active')
            });
			this.actions.isClickFullScreenBtn()
            this.hideLoading();
            //this.actions.setConditionHeight()
        },
        //拼接渲染组件需要的数据
        itemOnSelect: function(item){
            let selectValue = []
            this.data.fieldsData.forEach((data)=> {
                if(item.id == data.searchField){
                    let obj = {};
                    obj['name'] = data.name;
                    obj['id'] = data.searchField;
                    obj['type'] = data.searchType;
                    let fieldContent = [];
                    // let multChoosed = [];
                    for(let i in data.fieldContent) {
                        let d = {};
                        d['id'] = i;
                        d['name'] = data.fieldContent[i];
                        d['py'] = data.fieldContent[i];
                        fieldContent.push(d);
                        // if(it.multChoosed && it.multChoosed.length > 0){
                        //     it.multChoosed.split(',').forEach((itemMult)=> {
                        //         if(itemMult === data.fieldContent[i]){
                        //             let m={};
                        //             m['id'] = i;
                        //             m['name'] = data.fieldContent[i];
                        //             m['py'] = data.fieldContent[i];
                        //             multChoosed.push(m)
                        //         }
                        //     })
                        // }
                    };
                    // obj['multChoosed'] = multChoosed;
                    obj['fieldContent'] = fieldContent;
                    obj['isAdd'] = item['isAdd'];
                    if(selectValue.indexOf(item.name) === -1) {
                        selectValue.push(obj);
                    }
                }
            })
            return selectValue;
        },
        //初始化当前选中项
        checkedQuery(choosedCurrent){
            if(!choosedCurrent.checked){
                this.actions.removeSelf(choosedCurrent.id);
                if (this.data.isAdQuery) {
                    this.actions.addQueryOptimization()
                }
                return;
            }
            let selectValue = this.actions.itemOnSelect(choosedCurrent);
            if(this.data.renderId != choosedCurrent.id){
                this.data.renderId=choosedCurrent.id;
                this.actions.renderQuery(selectValue,true);
            }else{
                this.actions.renderQuery(selectValue,false);
            }
        },
        //删除当前选中项
        removeSelf(id){
            this.data.childComponents[id]._destroy();
        },
        //渲染当前选中项
        renderQuery(selectValue,isFirst){
            let epCondition = new expertConditionAdQuery({data:Object.assign({expertItemData:selectValue},{isAdd:selectValue[0]['isAdd']})});
            if(selectValue[0]['isAdd']){
                this.append(epCondition, this.data.renderDom[0].children);
            }else {
                let dom = document.createElement('div');
                dom.className = 'condition-search-choice';
                this.append(epCondition, $(dom));
                if(isFirst){
                    this.data.renderDom=$(dom);
                }
                $(dom).appendTo(this.el.find('.condition-search-container'));
                this.data.childComponents[selectValue[0].id] = epCondition;
            }
            this.data.searchInputAry.push(epCondition.data);

            if (this.data.isAdQuery) {
                this.actions.addQueryOptimization()
            }

        },
        //简版高级查询优化 默认第一个字段括号显示蓝底背景，从第二个字段开始加上并且/或者
        addQueryOptimization(){
            let searchChild = this.el.find('.condition-search-container').children();
            let searchChildLen = searchChild.length;
            let searchItem=searchChild.children().children('.condition-search-item');
            let itemSiblings=searchItem.siblings();
            let lastRadio=searchItem.children('.radio');
            let name=searchItem.children('.type-name');
            let activeCss={'margin-left': '38px'};
            let numberInput=searchItem.children('.condition-search-value').children('.condition-search-input.number-input');
            numberInput.length&&numberInput.parent().css('margin-left','-19px')
            //如果展示常用查询，确保同字段的兄弟字段的并且/或者选框位置不变
            if (this.itemChecked) {
                itemSiblings.length&&itemSiblings.children().children('.radio').css('margin-left','-40px')&&itemSiblings.children().children('.radio').css('display','inline-block')
            }

            if (searchChildLen==1&&searchChild.height()) {
                searchItem.children('.left-choice,.right-choice').addClass('active');
                searchItem.children('.radio').css({'display':'none'});
                searchItem.children('.left-choice.active').css(activeCss);
                return
            }
             else if (searchChildLen>1) {
                searchItem.eq(0).children('.radio').css('display','none');
                searchItem.eq(0).children('.left-choice,.right-choice').addClass('active');
                searchItem.eq(0).children('.left-choice.active').css(activeCss);
                //判断字段是否是第一个，对并且/或者选框进行相应处理
               if (!name.length)return
               if (searchItem.length&&searchItem.length==1) {
                   searchItem.children('.radio').css('display','none');
                   searchItem.children('.left-choice.active').css(activeCss);
                   return
                }
                else {
                    lastRadio[lastRadio.length-1].style.display='inline-block';
                    lastRadio[lastRadio.length-1].style.verticalAlign='top';
                    lastRadio[lastRadio.length-1].style.marginLeft='-40px';
                }
            }
        },
    },
    afterRender: function() {
        this.showLoading();
        PMAPI.getIframeParams(window.config.key).then((res) => {
            for (let item in res.data.d) {
                this.data[item] = res.data.d[item]
            }
            this.actions.afterGetMsg();
        })
    }

});
// class expertSearch extends Component {
//     constructor(data,newConfig){
//         super($.extend(true,{},config,newConfig,{data:data||{}}));
//         console.log(this.data)
//     }
// }
export default expertSearch



// WEBPACK FOOTER //
// app/components/dataGrid/data-table-toolbar/expert-search/expert-search.js